import React from "react";
import cssClasses from "./Text.module.css";

const Text = ({
    variant = "default",
    size = "base",
    component = "p",
    children,
    className = "",
}) => {
    const _variant = getVariant(variant);
    const _size = getSize(size);
    return React.createElement(
        component,
        { className: `${cssClasses.text} ${_variant} ${_size} ${className}` },
        children,
    );
};

export default Text;

function getVariant(variant) {
    switch (variant) {
        case "title":
            return cssClasses.title;
        case "h4-title":
            return cssClasses["h4-title"];
        case "h5-title":
            return cssClasses["h5-title"];
        case "sm-title":
            return cssClasses["sm-title"];
        case "xs-subtitle":
            return cssClasses["xs-subtitle"];
        case "h6-title":
            return cssClasses["h6-title"];
        case "para-s":
            return cssClasses["para-s"];
        case "h3-title":
            return cssClasses["h3-title"];
        case "h2-title":
            return cssClasses["h2-title"];
        case "label-18px":
            return cssClasses["label-18px"];
        case "label-16px":
            return cssClasses["label-16px"];
        case "xxs-subtitle":
            return cssClasses["xxs-subtitle"];
        case "h1-title":
            return cssClasses["h1-title"];
        case "para-black":
            return cssClasses["para-black"];
        default:
            return cssClasses.body2;
    }
}
function getSize(size) {
    switch (size) {
        case "base":
            return cssClasses.base;
        case "sm":
            return cssClasses.sm;
        default:
            return cssClasses.base;
    }
}

function getWeight(size) {
    switch (size) {
        case "normal":
            return cssClasses.normal;
        case "medium":
            return cssClasses.medium;
        default:
            return cssClasses.normal;
    }
}
